export default {
      id: "network-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#network",
      toString: function () {
        return this.url;
      }
    }